import React, { useEffect, useRef, useState } from "react";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Button from "@material-ui/core/Button";

import Dropzone from "../micro_components/DropZone";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import { VscTriangleDown, VscTriangleUp } from "react-icons/vsc";

import "../styles/modalStyles.css";
import ChapterDataService from "../../services/ChapterService";

const PageDetailsV2 = ({
  page,
  removePage,
  insertPageAfter,
  movePageDown,
  movePageUp,
  setPageImage,
  bookId,
  chapterId,
  menuWidth,
  pageThumbHeight,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDropped, setIsDropped] = useState(false);
  const [contentImageURL, setContentImageURL] = useState();

  const [thumbModal, setThumbModal] = useState(false);
  const thumbModalRef = useRef();
  const [cropper, setCropper] = useState();
  const cropperRef = useRef();
  const [newThumb, setNewThumb] = useState();
  const [previewPageTitle, setPreviewPageTitle] = useState(`Page ${page.page_number || "1"}`);
  const [constrainThumb, setConstrainThumb] = useState(false);
  const [showCropper, setShowCropper] = useState(true);
  const [uploadingThumb, setUploadingThumb] = useState(false);
  const [croppedImage, setCroppedImage] = useState();
  const [hideGradient, setHideGradient] = useState(false);
  const [done, setDone] = useState(false);

  const localPage = page;

  useEffect(() => {
    // console.log("Page: ", page);
    //get content image

    if (page) {
      if (page.contentImageLink) {
        setContentImageURL(`https://d24hdgytax3x03.cloudfront.net/${bookId}/pages/${page.contentImageLink}`);
      }
    }
  }, [page]);

  const listStyle = {
    listStyleType: "none",
  };

  const arrowStyle = {
    transform: isDropped ? "rotate(90deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const labelStyle = {
    display: "flex",
    alignItems: "center",
    background: isHovered ? "#dedede" : "none",
    padding: "0.5rem 0",
    cursor: "pointer",
  };

  const contentStyle = {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    maxHeight: isDropped ? "191px" : "0",
    transition: "all 0.3s ease",
    marginLeft: "20px",
  };

  const fileDropStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1rem",
  };

  const thumbModalStyle = {
    // width: "500px",
    // height: "500px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
  };

  const toggleDrop = () => {
    setIsDropped(!isDropped);
  };

  const handleDelete = () => {
    removePage(localPage.page_number);
  };

  // const handleInsert = () => {
  //   insertPageAfter(localPage.page_number);
  // };

  const handleContentImageSet = (data) => {
    setPageImage(localPage.page_number, data);
  };

  const moveDown = (e) => {
    movePageDown(page.page_number); //from parent
    e.stopPropagation();
  };

  const moveUp = (e) => {
    movePageUp(page.page_number); //from parent
    e.stopPropagation();
  };

  const handleThumbModalClickOut = (e) => {
    if (!thumbModalRef.current.contains(e.target)) {
      setThumbModal(false);
      setNewThumb();
    }
  };

  const handleThumbChange = (e) => {
    if (e.target.files.length === 0) return;
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setNewThumb(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const toggleCropper = () => {
    setShowCropper(false);
    setTimeout(() => setShowCropper(true), 10);
  };

  const handleThumbUpload = () => {
    setCroppedImage(
      cropper
        .getCroppedCanvas({ width: menuWidth * 2, height: pageThumbHeight * 2, imageSmoothingQuality: "high" })
        .toDataURL()
    );
  };

  useEffect(() => setDone(false), [thumbModal]);

  useEffect(() => {
    if (croppedImage) {
      var arr = croppedImage.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      const data = new FormData();
      data.append("file", new File([u8arr], "test", { type: "image/png" }));
      data.append("pageId", page.id);
      setUploadingThumb(true);
      ChapterDataService.uploadPageThumbnail(chapterId, page.page_number, data).then(() => {
        setUploadingThumb(false);
        setDone(true);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [croppedImage]);

  return (
    <div>
      <div
        className="label"
        style={labelStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => toggleDrop()}
      >
        <span>
          <ChevronRightIcon style={arrowStyle} />
        </span>
        <div className="page-label">
          <li style={listStyle}>Page {localPage.page_number}</li>{" "}
          <div className="pages__arrows-container">
            <VscTriangleUp size={20} onClick={moveUp} className="page-arrow" />
            <VscTriangleDown size={20} onClick={moveDown} className="page-arrow" />
          </div>
        </div>
      </div>
      <div className="content" style={contentStyle}>
        <div style={fileDropStyle}>
          {/* <FileSelector
            setData={(data) => setThumbnail(data)}
            label={"Page Thumbnail"}
          /> */}
          <Dropzone
            originalFile={contentImageURL}
            label={"Content"}
            hideTopLabel={true}
            setFileData={handleContentImageSet}
            width={60}
            height={100}
          />
          <Button
            variant="contained"
            color="primary"
            style={{ height: "fit-content" }}
            onClick={() => setThumbModal(true)}
          >
            Page thumbnail
          </Button>
          {/* <FileSelector setData={(data) => setAudio(data)} label={"Audio"} /> */}
        </div>
        <div style={{ paddingTop: "10px", display: "flex" }}>
          <div style={{ marginLeft: "10px" }}>
            <Button
              size="small"
              color="secondary"
              startIcon={<DeleteForeverIcon />}
              style={{ marginLeft: "" }}
              onClick={handleDelete}
            >
              Delete Page
            </Button>
          </div>
        </div>
      </div>
      {thumbModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#00000050",
            zIndex: 99999,
          }}
          onMouseDown={handleThumbModalClickOut}
        >
          <div className="thumbnail-modal" ref={thumbModalRef} style={thumbModalStyle}>
            <div>
              <input type="file" onChange={handleThumbChange} style={{ marginBottom: "1rem" }} />
            </div>
            {newThumb && (
              <div>
                <input
                  type="checkbox"
                  id="constrain"
                  style={{ marginRight: "0.5rem" }}
                  value={constrainThumb}
                  onChange={(e) => {
                    setConstrainThumb(e.target.checked);
                    toggleCropper();
                  }}
                />
                <label htmlFor="constrain">Constrain crop to image bounds</label>
              </div>
            )}
            {showCropper ? (
              <Cropper
                style={{ width: 500, height: 400, margin: "0 auto" }}
                ref={cropperRef}
                onInitialized={(instance) => {
                  setCropper(instance);
                }}
                preview=".crop-preview"
                src={newThumb}
                aspectRatio={menuWidth / pageThumbHeight || 4.286}
                viewMode={constrainThumb ? 2 : 0}
                dragMode="move"
                restore
                modal
                highlight
              />
            ) : (
              <div style={{ width: 500, height: 400 }} />
            )}
            <div
              style={{
                display: newThumb ? "block" : "none",
              }}
            >
              <hr />
              <div>
                <span style={{ fontSize: "1.4rem", fontWeight: 600 }}>Preview</span>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1rem",
                    marginTop: "0.5rem",
                  }}
                >
                  <div>
                    <span>Title: </span>
                    <input type="text" value={previewPageTitle} onChange={(e) => setPreviewPageTitle(e.target.value)} />
                  </div>
                </div>
                <label style={{ fontSize: "0.9rem", marginTop: "0.5rem" }}>
                  <input
                    type="checkbox"
                    style={{ marginRight: "0.25rem" }}
                    checked={hideGradient}
                    onChange={(e) => {
                      setHideGradient(e.target.checked);
                    }}
                  />
                  <span
                    style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}
                    title="To hide it in the reader, go to Edit Details and open the same menu for changing the thumbnail size"
                  >
                    Hide gradient (Preview only!)
                  </span>
                </label>
              </div>
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    position: "relative",
                    width: menuWidth,
                    height: pageThumbHeight,
                    margin: "1rem auto 0 auto",
                  }}
                >
                  <div
                    className="crop-preview"
                    style={{
                      width: menuWidth,
                      height: pageThumbHeight,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "2rem",
                      background: hideGradient ? null : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                      overflow: "hidden",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: '"Roboto condensed", sans-serif',
                        color: "white",
                        fontWeight: 800,
                        fontSize: "19.2px",
                        lineHeight: "19.2px",
                        maxWidth: "60%",
                        textAlign: "start",
                      }}
                    >
                      {previewPageTitle}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                <Button
                  disabled={uploadingThumb}
                  color="primary"
                  onClick={() => {
                    done ? setThumbModal(false) : handleThumbUpload();
                  }}
                >
                  {uploadingThumb ? "Uploading" : done ? "Done" : "Upload"}
                </Button>
                {!done && (
                  <Button
                    color="secondary"
                    onClick={() => {
                      setThumbModal(false);
                      setNewThumb();
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageDetailsV2;
